<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-img
          src="../../../../assets/figmaIcons/white/big-data.svg"
          max-width="55%"
        ></v-img>
      </div>
      <span class="main-toolbar-title">Big Data</span>
    </div>

    <div class="hidden-md-and-up mt-4">
      <v-tabs
        :height="40"
        :mobile-break-point="300"
        v-model="tab"
        class="ma-auto"
        icons-and-text
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              v-on="on"
              v-bind="attrs"
              href="#tabManufacturer"
              v-show="visible"
            >
              <v-icon>mdi-factory</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Fabricante/Modelo') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              v-on="on"
              v-bind="attrs"
              href="#tabEquipment"
              v-show="visible"
            >
              <v-icon>mdi-signal</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Equipamentos') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              v-on="on"
              v-bind="attrs"
              href="#tabTimes"
              v-show="visible"
            >
              <v-icon>mdi-timer-sand-empty</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Cronograma') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              v-on="on"
              v-bind="attrs"
              href="#tabServiceOrder"
              v-show="visible"
            >
              <v-icon>mdi-currency-usd</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Ordem de Serviço') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              v-on="on"
              v-bind="attrs"
              href="#tabCalls"
              v-show="visible"
            >
              <v-icon>mdi-star</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Chamado') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              v-on="on"
              v-bind="attrs"
              href="#tabReports"
              v-show="visible"
            >
              <v-icon>mdi-chart-arc</v-icon>
            </v-tab>
          </template>
          <span>Relatórios Quantitativos</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              v-on="on"
              v-bind="attrs"
              href="#tabQuality"
              v-show="visible"
            >
              <v-icon>mdi-star</v-icon>
            </v-tab>
          </template>
          <span>Qualidade</span>
        </v-tooltip>

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              v-on="on"
              v-bind="attrs"
              href="#tabDashboard"
              v-show="visible"
            >
              <v-icon>mdi-view-dashboard-variant</v-icon>
            </v-tab>
          </template>
          <span>Dashboard</span>
        </v-tooltip> -->
      </v-tabs>
    </div>

    <div class="hidden-sm-and-down mt-4">
      <v-tabs
        :height="40"
        :mobile-break-point="360"
        v-model="tab"
        class="ma-0 rounded-lg"
        icons-and-text
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab
          active-class="activated-tab"
          href="#tabManufacturer"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Fabricante/Modelo') }}
          <v-icon class="mt-1 mr-2">mdi-factory</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          href="#tabEquipment"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Equipamentos') }}
          <v-icon class="mt-1 mr-2">mdi-signal</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          href="#tabTimes"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Cronograma') }}
          <v-icon class="mt-1 mr-2">mdi-timer-sand-empty</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          href="#tabServiceOrder"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Ordem de Serviço') }}
          <v-icon class="mt-1 mr-2">mdi-currency-usd</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          href="#tabCalls"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Chamado') }}
          <v-icon class="mt-1 mr-2">mdi-star</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          href="#tabReports"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Relatórios Quantitativos') }}
          <v-icon class="mt-1 mr-2">mdi-chart-arc</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          href="#tabQuality"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Relatórios Qualidade') }}
          <v-icon class="mt-1 mr-2">mdi-star</v-icon>
        </v-tab>
        <!-- <v-tab
          active-class="activated-tab"
          href="#tabDashboard"
          class="rounded-lg rounded-b-0"
          v-show="visible"
        >
          {{ $t('Dashboard') }}
          <v-icon class="mt-1 mr-2">mdi-view-dashboard-variant</v-icon>
        </v-tab> -->
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tabManufacturer">
        <Manufacturer />
      </v-tab-item>
      <v-tab-item value="tabEquipment">
        <EquipmentTemplate @toSchedule="tab = 'tabTimes'" />
      </v-tab-item>
      <v-tab-item value="tabTimes">
        <ScheduleTemplate />
      </v-tab-item>
      <v-tab-item value="tabServiceOrder">
        <ServiceOrderTemplate />
      </v-tab-item>
      <v-tab-item value="tabCalls">
        <CalledsTemplate />
      </v-tab-item>
      <v-tab-item value="tabReports">
        <Reports />
      </v-tab-item>
      <v-tab-item value="tabQuality">
        <Quality />
      </v-tab-item>
      <!-- <v-tab-item value="tabDashboard">
        <Dashboard />
      </v-tab-item> -->
    </v-tabs-items>
  </v-card>
</template>

<script>
import EquipmentTemplate from './equipmentTemplate.vue'
import ScheduleTemplate from './scheduleTemplate.vue'
import ServiceOrderTemplate from './serviceOrderTemplate.vue'
import CalledsTemplate from '../components/Calleds/calleds/calleds.vue'
import Reports from '../components/Reports/reports.vue'
import Quality from '../components/quality/serviceOrderRatings.vue'
import Manufacturer from '../components/manufacturer.vue'
// import Dashboard from '../components/dashboard.vue'

export default {
  components: {
    EquipmentTemplate,
    ScheduleTemplate,
    ServiceOrderTemplate,
    CalledsTemplate,
    Reports,
    Manufacturer,
    Quality,
    // Dashboard,
  },
  data() {
    return {
      tab: null,
      visible: true,
    }
  },
}
</script>

<style scoped>
.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
  flex-direction: row-reverse;
}

.v-tab.v-tab {
  color: #bbcf20;
}

.v-tab {
  text-transform: none;
}

.v-tab--active {
  background-color: #e7eaeb;
}
</style>
